/* Imports */
import React from "react"
import { Slideshow, Image } from "fajny-react"
import { v4 as uuid } from "uuid"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const SlideshowPage = () => {
    const images = [
        "https://images.unsplash.com/photo-1636390785258-f59cd6883a03?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",
        "https://images.unsplash.com/photo-1636390785299-b4df455163dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",
        "https://images.unsplash.com/photo-1634705146926-b8fbca28f431?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1928&q=80",
        "https://images.unsplash.com/photo-1636207543865-acf3ad382295?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
    ]

    const items = [
        {
            title: "With controls and pagination",
            content: (
                <Slideshow controls pagination>
                    {images.map(image => (
                        <Image src={image} alt="Image slideshow" key={uuid()} />
                    ))}
                </Slideshow>
            ),
            code: 'const images = [\n    "https://images.unsplash.com/photo-1636390785258-f59cd6883a03?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1636390785299-b4df455163dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1634705146926-b8fbca28f431?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1928&q=80",\n    "https://images.unsplash.com/photo-1636207543865-acf3ad382295?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",\n]\n\n<Slideshow controls pagination>\n    {images.map(image => (\n        <Image src={image} alt="Image slideshow" key={uuid()} />\n    ))}\n</Slideshow>',
        },
        {
            title: "Autoplay",
            content: (
                <Slideshow autoplay={3000}>
                    {images.map(image => (
                        <Image src={image} alt="Image slideshow" key={uuid()} />
                    ))}
                </Slideshow>
            ),
            code: 'const images = [\n    "https://images.unsplash.com/photo-1636390785258-f59cd6883a03?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1636390785299-b4df455163dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1634705146926-b8fbca28f431?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1928&q=80",\n    "https://images.unsplash.com/photo-1636207543865-acf3ad382295?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",\n]\n\n<Slideshow autoplay={3000}>\n    {images.map(image => (\n        <Image src={image} alt="Image slideshow" key={uuid()} />\n    ))}\n</Slideshow>',
        },
    ]

    const propsItems = [
        {
            name: "controls",
            type: "Boolean",
        },
        {
            name: "pagination",
            type: "Boolean",
        },
        {
            name: "autoplay",
            type: "Number (in ms)",
            example: "2000",
            default: "1000",
        },
        {
            name: "iconPrev",
            type: "String",
            example: "arrow-left",
        },
        {
            name: "iconNext",
            type: "String",
            example: "arrow-right",
        },
        {
            name: "fajnyIconPrev",
            type: "String",
            example: "arrow-left-regular",
            possible: commonProps.fajnyIcons,
            default: "chevron-left-solid",
            required: "",
        },
        {
            name: "fajnyIconNext",
            type: "String",
            example: "arrow-right-regular",
            possible: commonProps.fajnyIcons,
            default: "chevron-right-solid",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default SlideshowPage
